import React, { useState } from "react";
import {
  adminService,
  VerifyAdminResponse,
} from "../../../../services/api/settings";
// import SelectDropdown from "../../../../components/elements/forms/Select";
// import { useVerifyAdmin } from "./useAdmin";

// const TIER_OPTIONS = [
//   { id: "PROFESSIONAL", name: "Professional" },
//   { id: "ENTERPRISE", name: "Enterprise" },
//   { id: "ENTERPRISEPLUS", name: "Enterprise Plus" },
// ] as const;

interface VerifyAdminButtonProps {
  organizationId: string | undefined;
  isVerified?: boolean;
  onVerificationSuccess?: (response: VerifyAdminResponse) => void;
  onVerificationError?: (error: Error) => void;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

const VerifyAdminButton: React.FC<VerifyAdminButtonProps> = ({
  organizationId,
  isVerified = false,
  onVerificationSuccess,
  onVerificationError,
  className = "",
  disabled = false,
  children = "Verify Account",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  // const { data, errors, onChangeSelect, validate } =
  //   useVerifyAdmin(organizationId);

  const handleVerify = async () => {
    // Validate inputs
    // if (!validate()) {
    //   return;
    // }

    // if (isLoading || disabled || !organizationId || !data.tier) {
    if (isLoading || disabled || !organizationId || isVerified) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await adminService.verifyAdmin(
        organizationId,
        "" // data.tier - commented out tier requirement
      );
      onVerificationSuccess?.(response);
    } catch (error) {
      console.error("Verification failed:", error);
      onVerificationError?.(error as Error);
    } finally {
      setIsLoading(false);
    }
  };

  // const isVerifyDisabled =
  //   isLoading || disabled || !organizationId || !data.tier;
  const isVerifyDisabled =
    isLoading || disabled || !organizationId || isVerified;

  return (
    <div className="flex items-center">
      {/* <SelectDropdown
        items={[
          { id: "PROFESSIONAL", name: "Professional" },
          { id: "ENTERPRISE", name: "Enterprise" },
          { id: "ENTERPRISEPLUS", name: "Enterprise Plus" },
        ]}
        name="tier"
        label="Select Tier"
        value={data.tier || ""}
        error={errors.tier || ""}
        onChange={onChangeSelect}
      /> */}
      <div
        onClick={handleVerify}
        className={`
        rounded-[15px] bg-primary text-white py-2 px-4 
        transition-all duration-200 ease-in-out ml-2 mt-3
        ${
          isVerifyDisabled
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer hover:bg-primary-dark active:scale-95"
        }
        ${
          isLoading || disabled
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer hover:bg-primary-dark active:scale-95"
        }
        ${className}
      `}
        role="button"
        tabIndex={0}
        aria-disabled={isLoading || disabled || isVerified}
        onKeyDown={(e) => {
          if ((e.key === "Enter" || e.key === " ") && !isVerifyDisabled) {
            e.preventDefault();
            handleVerify();
          }
        }}
      >
        {isLoading ? (
          <div className="flex items-center justify-center">
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
            Verifying...
          </div>
        ) : isVerified ? (
          "Verified"
        ) : (
          children
        )}
      </div>
      {/* {errors.tier && (
        <p className="text-red-500 text-sm mt-1">{errors.tier}</p>
      )}

      {!organizationId && (
        <p className="text-amber-500 text-sm">
          Organization ID is required for verification
        </p>
      )} */}
    </div>
  );
};

export default VerifyAdminButton;
